import React from "react";
import { Trans } from "react-i18next";

export function LicenseText() {
    return (
        <Trans>
            Лицензиат: Nivel Information Technology LLC, компания, зарегистрированная в Объединенных Арабских Эмиратах
            под регистрационным номером 1863794 по адресу Офис 1301-02 GREEN TOWER, BANIYAS ROAD, P.O. BOX 111881,
            Дубай, ОАЭ
        </Trans>
    );
}
